/*
 * Filename: private-route.tsx
 * Description: rounter component.
 */

import React, { ReactElement } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useHistory } from 'react-router';
import { History } from 'history';
import { CQAppConstant } from '../app-constants';
import Cookies from 'universal-cookie';

export const RedirectTo = (redirectProp: any): ReactElement => {
    const history: History = useHistory();
    history.push(redirectProp.to);
    return <></>;
};

export const PrivateRoute = (routeProps: any): ReactElement => {
    const cookie = new Cookies();
    return (
        <Route
            component={(props:any) => {
                const isAuthenticated = cookie.get(CQAppConstant.JWT_KEY);
                return (isAuthenticated)
                    ? <routeProps.component {...props}/> : <Redirect to={{
                        pathname: CQAppConstant.NAVIGATION.DEFAULT_PATH
                    }} {...props}/>;
            }}
        />
    );
};
